

export const TYPES = {
    IConfigurationService: Symbol('IConfigurationService'),
    IJSONEditingService: Symbol('IJSONEditingService'),
};


